import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSideArea = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 20,
	viewBox: "0 0 18 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.748 1.06543L16.248 3.06543L16.5 3.20996V13.8223L16.207 13.9551L5.20703 18.9551L4.97363 19.0605L4.75195 18.9346L1.25195 16.9346L1 16.79V6.17773L1.29297 6.04492L12.293 1.04492L12.5264 0.939453L12.748 1.06543ZM2 6.82129V16.209L5.02637 17.9385L15.5 13.1777V3.79004L12.4727 2.06055L2 6.82129Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 8.5L16 3.5V13.5L5 18.5V8.5Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.12109 8.78125L5.87891 9.21875L1.37891 6.71875L1.62109 6.28125L6.12109 8.78125Z",
			fill: "black"
		})
	]
});
export default SvgSideArea;
